<div class="image-details">
    <div fxFlex="650px">
        <div class="image-holder" [ngClass]="{quiz: quiz, mobile: imagesService.isMobileOnlyImage(image) && !showDesktop, adsTab: adsTab}" fxLayout="row">
            <div class="left" *ngIf="!imagesService.isMobileOnlyImage(image) || showDesktop || adsTab">

                <ng-container *ngIf="adsTab; else quizEl">
                    <cropper
                        #cropper
                        #desktopCropper
                        [canEdit]="canEdit" 
                        [image]="image"
                        [size]="sizes.ad">
                    </cropper>
                </ng-container>

                <ng-template #quizEl>
                    <cropper
                        #cropper
                        *ngIf="quiz && image.sizes.quiz && !adsTab; else normalEl"
                        [canEdit]="canEdit" 
                        [image]="image"
                        [size]="sizes.quiz">
                    </cropper>
                </ng-template>

                <ng-template #normalEl>
                    <cropper
                        #cropper
                        #desktopCropper
                        *ngIf="image.sizes.desktop && !adsTab; else fullSizeEl"
                        [canEdit]="canEdit" 
                        [image]="image"
                        [size]="sizes.desktop">
                    </cropper>
                </ng-template>

                <ng-template #fullSizeEl>
                    <cropper
                        #cropper
                        *ngIf="!adsTab"
                        [canEdit]="canEdit"
                        [image]="image">
                    </cropper>
                </ng-template>

            </div>
            <div class="right" fxFlex="{{ imagesService.isMobileOnlyImage(image) && !showDesktop ? '100' : '31.3'}}" *ngIf="!adsTab && (image.sizes.full.width < 600 || !quiz)">
                <cropper
                    #cropper
                    *ngIf="image.sizes.mobile; else mediumSizeEl"
                    [canEdit]="canEdit" 
                    [image]="image"
                    [size]="sizes.mobile">
                </cropper>
                <ng-template #mediumSizeEl>
                    <cropper
                        #cropper
                        [canEdit]="canEdit" 
                        [image]="image"
                        [size]="sizes.medium">
                    </cropper>
                </ng-template>
                <cropper
                    #cropper
                    *ngIf="image.sizes.feed_applenews; else applenewsSizeEl"
                    [canEdit]="canEdit" 
                    [image]="image"
                    [size]="sizes.feed_applenews">
                </cropper>
                <ng-template #applenewsSizeEl>
                    <cropper
                        #cropper
                        [canEdit]="canEdit" 
                        [image]="image"
                        [size]="sizes.feed_applenews">
                    </cropper>
                </ng-template>
            </div>
        </div>
    </div>
    <div fxFlex fxLayout="column">
        <div class="details" fxFlex fxLayout="column" fxLayoutGap="10px">
            <div class="wysiwyg" *ngIf="!adsTab">
                <label>Image title</label>
                <richtext
                    class="h2"
                    [(value)]="image.title"
                    (valueChange)="titleChange()"
                    placeholder="Image title"
                    *ngIf="canEdit; else titleText"
                    [dialog]="dialog"
                    [removeButtons]="true">
                </richtext>
                <ng-template #titleText>
                    <div [ngClass]="{faded: !image.title}">{{image.title ? image.title : 'Image title'}}</div>
                </ng-template>
                <div class="word-count"></div>
            </div>
            <div class="wysiwyg" *ngIf="!adsTab">
                <label>Alt Text</label>
                <richtext
                    [(value)]="image.alt"
                    (valueChange)="altChange()"
                    placeholder="Alt text"
                    *ngIf="canEdit; else altText"
                    [dialog]="dialog"
                    [removeButtons]="true">
                </richtext>
                <ng-template #altText>
                    <div [ngClass]="{faded: !image.alt}">{{image.alt ? image.alt : 'Alt text'}}</div>
                </ng-template>
                <div class="word-count"></div>
            </div>
            <div class="wysiwyg" *ngIf="!adsTab">
                <label>Caption</label>
                <richtext
                    [(value)]="image.caption"
                    (valueChange)="save()"
                    placeholder="Caption"
                    *ngIf="canEdit; else captionText"
                    [dialog]="dialog">
                </richtext>
                <ng-template #captionText>
                    <div [innerHtml]="image.caption ? image.caption : 'Caption'"></div>
                </ng-template>
                <div class="word-count" [ngClass]="{error: getCharacterCount() > 45}">{{getCharacterCount()}}/{{captionCharacterCount}}</div>
            </div>
            <div id="options-panel">
                <label>Brightness</label>
                <mat-slider [disabled]="canEdit !== true" min="-0.75" max="0.75" step=".05" [(value)]="brightness" (change)="optionChange($event, 'brightness')"></mat-slider>
                <label>Contrast</label>
                <mat-slider [disabled]="canEdit !== true" min="-0.5" max="0.5" step=".01" [(value)]="contrast" (change)="optionChange($event, 'contrast')"></mat-slider>
                <div class="actions">
                    <img *ngIf="saving" class="loader" src="/wp-content/themes/swarm/app/assets/images/loading.gif">
                    <button [disabled]="canEdit !== true" (click)="resetOptions()"><mat-icon>replay</mat-icon></button>
                </div>
            </div>
            <ng-container *ngIf="!quiz && !adsTab">
                <div>
                    <mat-checkbox [disabled]="canEdit !== true" [(ngModel)]="image.allowLandscape" (change)="allowLandscapeChange($event)"> Allow nonstandard on mobile</mat-checkbox>
                </div>
                <ng-container *ngIf="!imagesService.isMobileOnlyImage(image) || showDesktop">
                    <div>
                        <mat-checkbox id="allowPortrait" name="allowPortrait" [disabled]="canEdit !== true" [(ngModel)]="image.allowPortrait" (change)="allowPortraitChange($event)"> Allow nonstandard on desktop</mat-checkbox>
                    </div>
                    <div *ngIf="hasSmallDesktop()">
                        <mat-checkbox id="allow600" name="allow600" [disabled]="canEdit !== true" [(ngModel)]="image.allow600" (change)="allow600Change($event)"> Allow small on desktop</mat-checkbox>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngFor="let technique of techniques">
                <label>{{technique.label}}</label>
                <select [disabled]="canEdit !== true" [(ngModel)]="image.techniques && image.techniques[technique.label]" (change)="updateTechnique(technique.label, $event.target.value)">
                    <option value="">Select Technique</option>
                    <option *ngFor="let option of technique.options" [value]="option.value">{{option.name}}</option>
                </select>
            </ng-container>
        </div>
        <div class="actions">
            <label *ngIf="mustAddDetails"><span class="warn">Please make sure Image Title, Alt Text and Caption are present</span></label>
            <a href="{{imagesService.getDownloadUrl(image)}}" class="download" title="Download image" target="_blank" download>
                <mat-icon class="invert">publish</mat-icon>
            </a>
            <button 
                *ngIf="addToSlide"
                type="button"
                class="button"
                (click)="exit('addToSlide')">
                Add to Slide
            </button>
        </div>
    </div>
</div>